import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const categories = [
  { id: "all", name: "Tất cả" },
  { id: "coffee", name: "Cà phê" },
  { id: "tea", name: "Trà & Milk Tea" },
  { id: "smoothie", name: "Sinh tố & Đá xay" },
  { id: "bakery", name: "Bánh ngọt" },
  { id: "snack", name: "Ăn vặt" },
];

const menuItems = [
  {
    id: 1,
    name: "Cà phê Đen Đá",
    category: "coffee",
    price: 25000,
    desc: "Hương vị cà phê Robusta đậm đà truyền thống.",
    image:
      "https://images.unsplash.com/photo-1559496417-e7f25cb247f3?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 2,
    name: "Cà phê Sữa Đá",
    category: "coffee",
    price: 29000,
    desc: "Sự kết hợp hoàn hảo giữa cà phê đậm và sữa đặc ngọt ngào.",
    image:
      "https://images.unsplash.com/photo-1572097662959-5982e54727a7?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 3,
    name: "Latte Art",
    category: "coffee",
    price: 45000,
    desc: "Espresso nồng nàn với lớp bọt sữa mịn màng nghệ thuật.",
    image:
      "https://images.unsplash.com/photo-1551024601-5629f977c2aa?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 4,
    name: "Trà Đào Cam Sả",
    category: "tea",
    price: 45000,
    desc: "Thanh mát giải nhiệt với miếng đào giòn ngọt.",
    image:
      "https://images.unsplash.com/photo-1541170940552-307ba72cb576?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 5,
    name: "Trà Sữa Trân Châu",
    category: "tea",
    price: 42000,
    desc: "Vị trà sữa truyền thống thơm béo kèm trân châu dai dai.",
    image:
      "https://images.unsplash.com/photo-1563227812-0ea4c22e6cc8?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 6,
    name: "Sinh Tố Bơ",
    category: "smoothie",
    price: 49000,
    desc: "Bơ sáp tươi ngon xay cùng sữa đặc béo ngậy.",
    image:
      "https://images.unsplash.com/photo-1623812837687-1422ab8e61fb?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 7,
    name: "Croissant Bơ",
    category: "bakery",
    price: 35000,
    desc: "Bánh sừng bò nướng giòn rụm thơm lừng mùi bơ.",
    image:
      "https://images.unsplash.com/photo-1555507036-ab1f4038808a?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 8,
    name: "Tiramisu",
    category: "bakery",
    price: 40000,
    desc: "Bánh ngọt phong cách Ý mềm mịn, đắng nhẹ vị cacao.",
    image:
      "https://images.unsplash.com/photo-1571115177098-24ec42ed204d?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: 9,
    name: "Khoai Tây Chiên",
    category: "snack",
    price: 30000,
    desc: "Chiên vàng giòn rụm, lắc phô mai thơm lừng.",
    image:
      "https://images.unsplash.com/photo-1630384060421-a4323ce56d43?auto=format&fit=crop&q=80&w=400",
  },
];

function Menu() {
  const [activeCategory, setActiveCategory] = useState("all");

  const filteredItems =
    activeCategory === "all"
      ? menuItems
      : menuItems.filter((item) => item.category === activeCategory);

  const formatPrice = (price) => {
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(price);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
        paddingBottom: "80px",
      }}
    >
      {/* Header */}
      <div
        className="text-center py-5 mb-4"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "#fff",
        }}
      >
        <Container>
          <h1 className="fw-bold mb-3">Thực Đơn UC Coffee</h1>
          <p className="opacity-75 fs-5">
            Thưởng thức hương vị tuyệt vời trong không gian sáng tạo
          </p>
        </Container>
      </div>

      <Container>
        {/* Category Filter */}
        <div className="d-flex flex-wrap justify-content-center gap-2 mb-5">
          {categories.map((cat) => (
            <div
              key={cat.id}
              className={`px-4 py-2 rounded-pill fw-semibold ${
                activeCategory === cat.id ? "text-white" : "bg-white text-dark"
              }`}
              style={{
                cursor: "pointer",
                transition: "all 0.3s",
                background:
                  activeCategory === cat.id
                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                    : "white",
                border: activeCategory === cat.id ? "none" : "2px solid #ddd",
              }}
              onClick={() => setActiveCategory(cat.id)}
              onMouseEnter={(e) => {
                if (activeCategory !== cat.id) {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(0,0,0,0.15)";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              {cat.name}
            </div>
          ))}
        </div>

        {/* Product Grid */}
        <Row className="g-4">
          {filteredItems.map((item) => (
            <Col key={item.id} md={6} lg={4} xl={3}>
              <Card
                className="h-100 border-0 shadow-sm"
                style={{
                  transition: "all 0.3s",
                  borderRadius: "20px",
                  overflow: "hidden",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.boxShadow =
                    "0 15px 35px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
                }}
              >
                <div style={{ position: "relative", overflow: "hidden" }}>
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-100"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                      transition: "transform 0.3s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.1)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />
                  <div
                    className="position-absolute top-0 end-0 m-3 px-3 py-2 rounded-pill fw-bold text-white"
                    style={{
                      background:
                        "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                      fontSize: "0.9rem",
                    }}
                  >
                    {formatPrice(item.price)}
                  </div>
                </div>
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="fw-bold mb-2">{item.name}</Card.Title>
                  <Card.Text className="text-muted small flex-grow-1">
                    {item.desc}
                  </Card.Text>
                  <button
                    className="btn w-100 text-white fw-semibold py-2 rounded-3 border-0"
                    style={{
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      transition: "all 0.3s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow =
                        "0 5px 15px rgba(102, 126, 234, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <i className="bi bi-plus-circle me-2"></i>Thêm vào đơn
                  </button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Floating Cart Button */}
      <div
        className="position-fixed bottom-0 end-0 m-4"
        style={{ zIndex: 1000 }}
      >
        <button
          className="btn btn-lg rounded-circle text-white shadow-lg border-0 position-relative"
          style={{
            width: "70px",
            height: "70px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            transition: "all 0.3s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.boxShadow =
              "0 10px 30px rgba(102, 126, 234, 0.5)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 0.5rem 1rem rgba(0,0,0,0.15)";
          }}
        >
          <i className="bi bi-basket2-fill fs-4"></i>
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style={{ fontSize: "0.75rem" }}
          >
            0
          </span>
        </button>
      </div>
    </div>
  );
}

export default Menu;
